// Долната лента на листа „Доставка": първата пречка пред записа и действията —
// Изтрий черновата · Запази временно · Запиши доставката (Ctrl/Cmd+Enter); при
// редакция: Отказ · Запази промените (първите две са общите
// `components/drafts/DraftFooterActions`). Сумите на десктоп са в реда „Общо"
// в дъното на решетката — тук се показват само когато редовете са карти.
import { useTranslation } from "react-i18next";
import { useInventoryShell } from "../../components/shell/InventoryShellContext";
import { useViewport } from "../../../../hooks/useViewport";
import { KbdChip } from "../../components/KbdChip";
import { PRIMARY_BUTTON_CLASS } from "../../components/list/buttonStyles";
import { DraftFooterActions, type DraftFooterProps } from "../../components/drafts/DraftWorksheetParts";
import { DRAFT_TEXTS } from "../../components/drafts/draftTexts";
import { formatPrice } from "./deliveryWorksheetShared";

type Props = {
  mode: "new" | "edit";
  totalNet: number;
  totalGross: number;
  vatApplies: boolean;
  issue: string | null;
  issueIsBlocking: boolean;
  saving: boolean;
  // черновата на нова доставка (components/drafts/DraftFooterActions) — въпросът
  // „Изтриване на незавършената доставка от …?" носи доставчика и редовете
  draft: DraftFooterProps;
  onCancel: () => void;
  onSave: () => void;
};

export const DeliveryWorksheetFooter = ({
  mode,
  totalNet,
  totalGross,
  vatApplies,
  issue,
  issueIsBlocking,
  saving,
  draft,
  onCancel,
  onSave,
}: Props) => {
  const { t } = useTranslation();
  const { isNarrow } = useInventoryShell();
  const { isDesktop } = useViewport();
  const total = (label: string, value: number, strong = false) => (
    <span className="flex items-baseline gap-[7px]">
      <span className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted">{label}</span>
      <span
        className={`font-sheet tabular-nums ${
          strong ? "text-xl font-bold text-brand-deep-ink" : "text-[17px] font-semibold text-ink"
        }`}
      >
        {formatPrice(value)}
      </span>
    </span>
  );
  return (
    <footer
      className={`flex shrink-0 flex-wrap items-center border-t border-shade-2 bg-panel ${
        isNarrow
          ? "gap-3 px-3.5 py-3 pb-[calc(12px+env(safe-area-inset-bottom,0px)*0.5)]"
          : "gap-6 px-6 py-3.5"
      }`}
    >
      {!isDesktop && vatApplies && total(t("inventoryPage.colNet"), totalNet)}
      {!isDesktop && vatApplies && total(t("inventoryPage.totalVat"), totalGross - totalNet)}
      {!isDesktop && total(t("inventoryPage.colGross"), totalGross, true)}
      {issue && (
        <span
          className={`text-[12.5px] font-semibold ${
            issueIsBlocking ? "text-danger-ink" : "text-brand-deep-ink"
          }`}
        >
          {issue}
        </span>
      )}
      <div className="flex-1" />
      <DraftFooterActions mode={mode} texts={DRAFT_TEXTS.delivery} onCancel={onCancel} {...draft} />
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        className={`${PRIMARY_BUTTON_CLASS} !px-[22px] !py-3 !text-sm ${
          isNarrow ? "flex-[1_1_100%]" : ""
        }`}
      >
        {mode === "edit" ? t("inventoryPage.wsSaveChanges") : t("inventoryPage.saveDelivery")}
        {!isNarrow && <KbdChip>Ctrl+Enter</KbdChip>}
      </button>
    </footer>
  );
};

export default DeliveryWorksheetFooter;
